export default "__VITE_ASSET__7ca963d8__"